<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            :placeholder="$t(fieldConfig.label)"
            size="small"
            @change="syncChange"
        >
            <ElOption
                v-for="option in matrixOptions"
                :key="option"
                :label="option"
                :value="option"
            />
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { ScoreMatrixOptions } from '../constants';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'score_matrix',
        },
    },
    computed: {
        matrixOptions() {
            return ScoreMatrixOptions;
        },
    },
};
</script>
